import React from "react";
export default () => (
  <div className="flex-container flex-center full-screen layout-vertical">
    <div className="icon-404" />
    <p className="tips">没有找到你访问的资源。</p>
  </div>
);
